import { render, staticRenderFns } from "./DigitalAccountLiquidationSwitch.vue?vue&type=template&id=1f9cfb44"
import script from "./DigitalAccountLiquidationSwitch.vue?vue&type=script&lang=js"
export * from "./DigitalAccountLiquidationSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports